export const AUTOPLAY_SPEED = 3000;
export const DEFAULT_VIDEO_ASPECT_RATIO = 16 / 9;
export const MOBILE_SQUARE_SIZE = 577;
